var render, staticRenderFns
import script from "./StatVisitsChart.vue?vue&type=script&lang=js&"
export * from "./StatVisitsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240e14a4",
  null
  
)

export default component.exports